export const START_DATE = 'startDate'
export const END_DATE = 'endDate'

export const LANGUAGE_LOCALSTORAGE_KEY = 'userLanguage'
export const CURRENCY_LOCALSTORAGE_KEY = 'userCurrency'
export const INSTALLATION_TOKEN_LOCALSTORAGE_KEY = 'mrparkit-installation-token'
export const PHONE_COUNTRY_LOCALSTORAGE_KEY = 'mrparkit-phone-country'
export const CHECKOUT_RESERVATION_TOKEN_SESSIONSTORAGE_KEY = 'mrparkit-reservation-token'

export const RESERVATION_MIN_HOURS = 6

export const API_KEY = import.meta.env.VITE_API_KEY
export const API_VERSION = import.meta.env.VITE_API_VERSION

export const WEB_ROUTE_SEGMENTS = {
    checkout: {
        cs: 'checkout',
        en: 'checkout',
        de: 'checkout',
        pl: 'checkout',
    },
    garageMap: {
        cs: 'garaze',
        en: 'garages',
        de: 'garagen',
        pl: 'garaze',
    }
}

export const WEB_PROFILE_ROUTE_SEGMENTS = {
    profile: {
        cs: 'profil',
        en: 'profile',
        de: 'profil',
        pl: 'profil',
    },
    reservations: {
        cs: 'rezervace',
        en: 'reservations',
        de: 'reservierungen',
        pl: 'rezerwacje',
    },
}

export const WEB_RESERVATION_ROUTE_SEGMENTS = {
    reservations: {
        cs: 'rezervace',
        en: 'reservations',
        de: 'reservierungen',
        pl: 'rezerwacje',
    },
    reservationTime: {
        cs: 'cas-rezervace',
        en: 'reservation-time',
        de: 'reservierungszeit',
        pl: 'czas-rezerwacji',
    },
}
